"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LanguageTextItem;
const React = require("react");
const LanguageItem_1 = require("./LanguageItem");
function LanguageTextItem({ code, text }) {
    return (React.createElement(LanguageItem_1.default, { code: code },
        React.createElement("span", { className: "h5 mt-2" }, text)));
}
